export const environment = {
  production: true,
  domain: 'https://www.pla22agurus.com:2083/',
  //domain: 'https://des-api.gurushonduras.com/',
  url_amazon_s3: 'https://plazza.s3.us-east-2.amazonaws.com/',
};
